import React from 'react'

import { useI18N } from '../../../libraries/i18n/hook'
import { OuterTabGroup } from '../../components/form/tab-groups'
import VideoGrid from '../../components/content/VideoGrid'
import DocumentGrid from '../../components/content/DocumentGrid'
import { useBookmarkedVideos } from '../../../hocs/content/useVideos'
import { useBookmarkedDocuments } from '../../../hocs/content/useDocuments'
import { useBookmarkedCourses } from '../../../hocs/content/useCourses'
import CoursesGrid from '../../components/content/courses/CoursesGrid'

const BookmarkedContent = () => {
  const { t } = useI18N()
  const [activeTab, setActiveTab] = React.useState<string>('videos')
  const { data: videos, isLoading: videosLoading, error: videosError } = useBookmarkedVideos()
  const { data: documents, isLoading: documentsLoading, error: documentsError } = useBookmarkedDocuments()
  const { data: courses, isLoading: coursesLoading, error: coursesError } = useBookmarkedCourses()
  return (
    <div>
      <OuterTabGroup
        tabs={[
          { id: 'videos', title: t('content.videos') },
          { id: 'documents', title: t('content.documents') },
          { id: 'courses', title: t('courses.title') },
        ]}
        handleClick={setActiveTab}
        active={activeTab}
      />
      {activeTab === 'videos' && <VideoGrid data={videos} isLoading={videosLoading} error={videosError} />}
      {activeTab === 'documents' && <DocumentGrid data={documents} isLoading={documentsLoading} error={documentsError} />}
      {activeTab === 'courses' && <CoursesGrid data={courses} isLoading={coursesLoading} error={coursesError} />}
    </div>
  )
}

export default BookmarkedContent
